var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735872510413,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2669,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M739.64 826H232.36A104.26 104.26 0 0 1 128 721.82V274.46a104.26 104.26 0 0 1 104.36-104.18h507.28A104.26 104.26 0 0 1 844 274.46v447.36A104.26 104.26 0 0 1 739.64 826z",
    fill: "#F1F3F5",
    "p-id": 2670
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.26 426.46m29.36 0l49.06 0q29.36 0 29.36 29.36l0 48.88q0 29.36-29.36 29.36l-49.06 0q-29.36 0-29.36-29.36l0-48.88q0-29.36 29.36-29.36Z",
    fill: "#CED4DA",
    "p-id": 2671
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M626.5 426.46m29.36 0l49.06 0q29.36 0 29.36 29.36l0 48.88q0 29.36-29.36 29.36l-49.06 0q-29.36 0-29.36-29.36l0-48.88q0-29.36 29.36-29.36Z",
    fill: "#CED4DA",
    "p-id": 2672
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M415.38 426.46m29.36 0l49.06 0q29.36 0 29.36 29.36l0 48.88q0 29.36-29.36 29.36l-49.06 0q-29.36 0-29.36-29.36l0-48.88q0-29.36 29.36-29.36Z",
    fill: "#CED4DA",
    "p-id": 2673
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.26 605.48m29.36 0l49.06 0q29.36 0 29.36 29.36l0 48.88q0 29.36-29.36 29.36l-49.06 0q-29.36 0-29.36-29.36l0-48.88q0-29.36 29.36-29.36Z",
    fill: "#CED4DA",
    "p-id": 2674
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M415.38 605.48m29.36 0l49.06 0q29.36 0 29.36 29.36l0 48.88q0 29.36-29.36 29.36l-49.06 0q-29.36 0-29.36-29.36l0-48.88q0-29.36 29.36-29.36Z",
    fill: "#CED4DA",
    "p-id": 2675
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M626.5 605.48m29.36 0l49.06 0q29.36 0 29.36 29.36l0 48.88q0 29.36-29.36 29.36l-49.06 0q-29.36 0-29.36-29.36l0-48.88q0-29.36 29.36-29.36Z",
    fill: "#CED4DA",
    "p-id": 2676
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.34 100.4h931.34v256.06H20.34z",
    fill: "#FF6B6B",
    "p-id": 2677
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.34 314.2h931.34v42.26H20.34z",
    fill: "#FA5252",
    "p-id": 2678
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.54 126m46.1 0l0.08 0q46.1 0 46.1 46.1l0 50.08q0 46.1-46.1 46.1l-0.08 0q-46.1 0-46.1-46.1l0-50.08q0-46.1 46.1-46.1Z",
    fill: "#495057",
    "p-id": 2679
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M620.18 126m46.1 0l0.08 0q46.1 0 46.1 46.1l0 50.08q0 46.1-46.1 46.1l-0.08 0q-46.1 0-46.1-46.1l0-50.08q0-46.1 46.1-46.1Z",
    fill: "#495057",
    "p-id": 2680
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M734 718m-190 0a190 190 0 1 0 380 0 190 190 0 1 0-380 0Z",
    fill: "#FCC419",
    "p-id": 2681
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M734 718m-151.6 0a151.6 151.6 0 1 0 303.2 0 151.6 151.6 0 1 0-303.2 0Z",
    fill: "#FFD43B",
    "p-id": 2682
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M766.54 676.32a10.42 10.42 0 0 1-13.26-2.3 18.78 18.78 0 0 0-4.7-4.2 25.62 25.62 0 0 0-27.68 2.2 16.26 16.26 0 0 0-6.1 12.98q0 10.78 16 17.36l14.7 6q18 7.26 26.24 17.7a40 40 0 0 1 8.26 25.62 45.02 45.02 0 0 1-13.54 33.58 46.5 46.5 0 0 1-33.88 13.36q-19.18 0-31.68-11.36a46.7 46.7 0 0 1-12.38-19.48 11.4 11.4 0 0 1 8.2-14.96 11.42 11.42 0 0 1 13.36 8.22 22 22 0 0 0 3.32 7.22q6.88 9.54 20 9.54a23.26 23.26 0 0 0 17.26-6.96 24 24 0 0 0 6.88-17.66 24.8 24.8 0 0 0-1.2-7.88 20 20 0 0 0-3.72-6.58 29.8 29.8 0 0 0-6.54-5.64 62.98 62.98 0 0 0-9.54-5l-14.22-6q-30.24-12.78-30.24-37.4a35.48 35.48 0 0 1 12.7-27.76 45.84 45.84 0 0 1 31.58-11.26 41.68 41.68 0 0 1 32.46 14.54 10.5 10.5 0 0 1-2.28 16.12z",
    fill: "#F08C00",
    "p-id": 2683
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M734 821.04a11.68 11.68 0 0 1-11.68-11.68v-13.26a11.68 11.68 0 0 1 23.34 0v13.26a11.68 11.68 0 0 1-11.66 11.68zM734 660.56a11.68 11.68 0 0 1-11.68-11.68v-13.26a11.68 11.68 0 1 1 23.34 0v13.26a11.68 11.68 0 0 1-11.66 11.68z",
    fill: "#F08C00",
    "p-id": 2684
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M478.48 511.44a15.22 15.22 0 0 1-10.78-4.46l-33.6-33.58a15.26 15.26 0 0 1 21.58-21.58l22.8 22.8 87.68-87.68a15.26 15.26 0 0 1 21.58 21.58l-98.48 98.48a15.2 15.2 0 0 1-10.78 4.44z",
    fill: "#12B886",
    "p-id": 2685
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.8b68d0b315e84d602a3487a04c8566d2.svg";
export { ForwardRef as ReactComponent };